import React from 'react';
import PageHeader from '../common/PageHeader';
import PageFilter from '../common/PageFilter';
import { controlType } from '../../constants/common';
import { apiBatchRequest, apiPut } from '../../utils/api_service';
import { API_URL } from '../../constants/api';
import { cloneDeep, getCurrentPayCycle, UpdateColumnWithConfiguration } from '../../utils/helper';
import { ShowToast, toastType } from '../../utils/toast-service';
import commonLabels from '../../constants/messageConstants';
import moment from 'moment';
import { GridTable } from '../common/Table/Table';
import { billingAdjustmentsConfig, billingAdjustmentsColumns, billingAdjustmentColumn, payCodeListColumn, overtimeListColumn } from '../../constants/MockData';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import SaveIcon from '@material-ui/icons/Save';
import ResetIcon from '@material-ui/icons/RestorePageOutlined';
import ClearIcon from '@material-ui/icons/Clear';
import {
  IconButton,
  Tooltip,
  Button,
  TextField,
  InputAdornment,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup
} from '@material-ui/core';
import ConfirmDialog from '../common/Dailogbox/confirmDailog';
import _ from 'lodash';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { getFormattedHeaders, getFormattedStringValues } from '../../utils/formatData';
import './index.less';
import Visibility from '@material-ui/icons/Visibility';
import AddIcon from '@material-ui/icons/Add';
import Autocomplete from '@material-ui/lab/Autocomplete';

// Component is used for Billing Adjustments
class BillingAdjustments extends React.PureComponent {
  // Constructor to set initial state of component
  constructor(props) {
    super(props);
    this.state = {
      billingAdjustmentsData: [],
      configuration: [],
      employeeMasterData: [],
      marketMasterData: [],
      payCycleData: [],
      responsePayCycleData: [],
      selectedData: [],
      defaultSelectedData: [],
      isInEditMode: false,
      isPopupOpen: false,
      confirmationMessage: '',
      periodStartDate: null,
      periodEndDate: null,
      employeeDetails: [],
      employeeConfiguration: [],
      payCodeList: [],
      radioValue: 'Amount Split',
      isEditable: true,
      previousPayCycleStartDate: null,
      selectedEmployeeId: 0,
      reloadTable: false,
      mode: '',
      allocationType: 'Market',
      previoslySelectedPayCycleStartDate: null,
      deletedRecord: [],
      originalMarketMasterData: [],
      allPayCodeList: [],
      originalPropertyMasterData: [],
      originalDivisionData: [],
      originalDepartmentData: []
    };
  }

  // Method to get data from API before components are mounted
  componentDidMount() {
    this.loadData();
  }

  // Get data from APIs
  loadData() {
    const selectedData = [];
    const date = getCurrentPayCycle();
    const date2 = moment(date[1]).subtract(1, 'days').format('MM/DD/YYYY');
    const day = new Date(date2).getDate();
    const date1 = day === 15
      ? moment(date[1]).subtract(15, 'days').format('MM/DD/YYYY')
      : moment(date2).startOf('month').add(15, 'days').format('MM/DD/YYYY');

    this._asyncRequest = apiBatchRequest([
      {
        url: API_URL.Employee.GetEmployeeMasterData + '?showInActive=true',
        key: 'employeeMasterData'
      },
      {
        url: API_URL.Market.GetMarketMasterdata,
        key: 'marketMasterData'
      },
      {
        url: API_URL.Report.GetPayCycle,
        key: 'payCycleData'
      },
      {
        url: API_URL.Property.GetPropertyMasterData,
        key: 'propertyMasterData'
      },
      {
        url: API_URL.Employee.GetReimbursementAdjustmentDetail + '?periodStartDate=' + date[1] + '&periodEndDate=' + date[0] + '&employeeId =' + this.state.selectedEmployeeId + '&adjustmentType=' + this.state.allocationType,
        key: 'billingAdjustmentsData'
      },
      {
        url: API_URL.Allocation.GetDivisions,
        key: 'originalDivisionData'
      },
      {
        url: API_URL.Employee.GetDepartmentMasterData + '?outputTypeName=AccessBased',
        key: 'originalDepartmentData',
        fromCache: true,
        duration: 60
      }
    ])
      .then(({ employeeMasterData, payCycleData, billingAdjustmentsData, marketMasterData, propertyMasterData, originalDivisionData, originalDepartmentData }) => {
        this._asyncRequest = null;
        if (employeeMasterData.success !== true) {
          ShowToast(commonLabels.somethingWrong, toastType.ERROR, 5000, 500, 'Server error');
        }
        selectedData.push(
          {
            key: 'payCycle',
            selected: (payCycleData.data.find(x => x.payCycle === (date[1] + '-' + date[0])) || {})
          },
          {
            key: 'allocationType',
            selected: [{ allocationType: 'Market' }]
          }
        );
        selectedData.push();
        this.setState({
          payCycleData: payCycleData.data || [],
          responsePayCycleData: payCycleData.data || [],
          employeeMasterData: employeeMasterData.data || [],
          marketMasterData: marketMasterData.data || [],
          originalMarketMasterData: marketMasterData.data || [],
          selectedData: selectedData || [],
          defaultSelectedData: cloneDeep(selectedData),
          billingAdjustmentsData: billingAdjustmentsData.data || [],
          originalBillingAdjustmentsData: billingAdjustmentsData.data || [],
          configuration: billingAdjustmentsData.config || [],
          periodStartDate: date[1],
          periodEndDate: date[0],
          previousPayCycleStartDate: date1,
          previoslySelectedPayCycleStartDate: date1,
          originalPropertyMasterData: propertyMasterData.data || [],
          originalDivisionData: originalDivisionData.data || [],
          originalDepartmentData: originalDepartmentData.data || []
        });
      })
      .catch(() => {
        this._asyncRequest = null;
      });
  }

  // Get list of employees with billing adjustments for selected pay period
  GetBillingAdjustmentEmployeeList = async (periodStartDate, periodEndDate) => {
    const allocationType = this.state.allocationType;
    this._asyncRequest = await apiBatchRequest([
      {
        url: API_URL.Employee.GetBillingAdjustmentEmployeeList + '?periodStartDate=' + periodStartDate + '&periodEndDate=' + periodEndDate + '&employeeId=0&adjustmentType=' + allocationType,
        key: 'employeeData'
      }
    ])
      .then(({ employeeData }) => {
        this.setState({
          employeeMasterData: employeeData.data,
          billingAdjustmentsData: [],
          originalBillingAdjustmentsData: [],
          selectedEmployeeId: 0,
          previoslySelectedPayCycleStartDate: periodStartDate
        });
      })
      .catch(() => {
        this.setState({
          employeeMasterData: [],
          billingAdjustmentsData: [],
          originalBillingAdjustmentsData: [],
          selectedEmployeeId: 0,
          previoslySelectedPayCycleStartDate: periodStartDate
        });
      });
  }

  // Get Reimbursement Adjustment details of the selected employee
  GetReimbursementAdjustmentDetail = (periodStartDate, periodEndDate, employeeId = 0) => {
    const allocationType = this.state.allocationType;
    this._asyncRequest = apiBatchRequest([
      {
        url: API_URL.Employee.GetReimbursementAdjustmentDetail + '?periodStartDate=' + periodStartDate + '&periodEndDate=' + periodEndDate + '&employeeId=' + employeeId + '&adjustmentType=' + allocationType,
        key: 'billingAdjustmentsData'
      }
    ])
      .then(({ billingAdjustmentsData }) => {
        this.setState({
          originalBillingAdjustmentsData: billingAdjustmentsData.data,
          billingAdjustmentsData: billingAdjustmentsData.data,
          isInEditMode: employeeId > 0,
          reload: !this.state.reloadTable
        });
      })
      .catch(() => {
        this.Clear();
      });
  }

  // Handle filter change event
  onFilterChange = (selectedData) => {
    let payCycleStart; let payCycleEnd; let isClosed = false;
    let selectedAllocationType;
    let employeeId = 0;
    const allocationType =
      selectedData.find((x) => x.key === 'allocationType') || {};
    if (
      allocationType &&
      allocationType.selected &&
      allocationType.selected.length === 1
    ) {
      selectedAllocationType = allocationType.selected[0].allocationType;
    }
    const selectedPayPeriod = selectedData.find((x) => x.key === 'payCycle') || {};

    if ((selectedPayPeriod?.selected?.payCycleStart !== selectedPayPeriod?.selected?.payCycleEnd) || selectedAllocationType === 'Market') {
      if (
        selectedPayPeriod &&
        selectedPayPeriod.selected
      ) {
        payCycleStart = selectedPayPeriod.selected.payCycleStart;
        payCycleEnd = selectedPayPeriod.selected.payCycleEnd;
        isClosed = selectedPayPeriod.selected.isClosed;
      }
    } else {
      const date = getCurrentPayCycle();
      selectedData = selectedData.filter((x) => x.key !== 'payCycle') || {};
      selectedData.push({
        key: 'payCycle',
        selected: (this.state.payCycleData.find(x => x.payCycle === (date[1] + '-' + date[0])) || {})
      });
      payCycleStart = date[1];
      payCycleEnd = date[0];
    }

    const selectedEmployee = selectedData.find((x) => x.key === 'employeeName') || {};
    if (
      selectedEmployee &&
      selectedEmployee.selected
    ) {
      employeeId = selectedEmployee.selected.employeeId;
    }

    // const { previoslySelectedPayCycleStartDate } = this.state;

    // if (moment(previoslySelectedPayCycleStartDate).format(DateFormat) !== moment(payCycleStart).format(DateFormat)) {
    //   await this.GetBillingAdjustmentEmployeeList(payCycleStart, payCycleEnd);
    // }
    // const isEditable = (moment(payCycleStart).format(DateFormat) === moment(this.state.previousPayCycleStartDate).format(DateFormat)
    //   || isDateInCurrentPayCycle(moment(payCycleStart).format(DateFormat)));
    // const isEditable = (new Date(moment(payCycleStart))) >= new Date(moment(this.state.previousPayCycleStartDate)) &&
    //   (new Date(moment(payCycleStart))) <= new Date(moment().endOf('month'));

    this.setState({
      periodStartDate: moment(payCycleStart).format('MM/DD/YYYY'),
      periodEndDate: moment(payCycleEnd).format('MM/DD/YYYY'),
      selectedData,
      isInEditMode: (employeeId !== undefined && employeeId > 0),
      employeeDetails: [],
      payCodeList: [],
      deletedRecord: [],
      employeeConfiguration: [],
      radioValue: 'Amount Split',
      selectedEmployeeId: employeeId,
      // isEditable: isEditable,
      mode: isClosed ? 'View' : '',
      allocationType: selectedAllocationType,
      payCycleData: selectedAllocationType === 'Market'
        ? this.state.responsePayCycleData
        : (this.state.responsePayCycleData || []).filter(x => x.payCycleEnd !== x.payCycleStart)
    }, () => {
      if (employeeId !== undefined && employeeId > 0) {
        const cellInfo = { payCycleStart: payCycleStart, payCycleEnd: payCycleEnd, employeeId: employeeId };
        this.EditRecord(cellInfo, employeeId, this.state.mode, isClosed);
      } else {
        this.GetReimbursementAdjustmentDetail(payCycleStart, payCycleEnd);
      }
    });
  }

  // Edit selected record
  EditRecord = (cellInfo, employeeId = 0, mode = '', isClosed = false) => {
    const { periodStartDate, periodEndDate, allocationType, selectedData, employeeMasterData } = this.state;
    const selectedData1 = selectedData;
    this._asyncRequest = apiBatchRequest([
      {
        url: API_URL.Employee.GetReimbursementAdjustmentDetail + '?periodStartDate=' + periodStartDate + '&periodEndDate=' + periodEndDate + '&employeeId=' + cellInfo.employeeId + '&showDetail=' + true + '&adjustmentType=' + allocationType,
        key: 'employeeDetails'
      }
    ])
      .then(({ employeeDetails }) => {
        employeeDetails.data.forEach(function (item, i) {
          if (item.payCodeTypeId === 4) {
            employeeDetails.data.splice(i, 1);
            employeeDetails.data.unshift(item);
          }
        });
        let payCodeList = [];
        let payStatement;
        mode = isClosed ? 'View' : mode;

        if (employeeDetails !== undefined && employeeDetails.data !== null && employeeDetails.data?.length > 0) {
          if (allocationType === 'Property OT') {
            // employeeDetails.data = employeeDetails.data.filter(x => x.payCodeTypeId === 4);
            if (isClosed === true) {
              mode = 'View';
              ShowToast(
                "Selected pay period is closed. You can't adjust the values.",
                toastType.INFO,
                5000,
                500);
            } else if (employeeDetails.data.filter(x => x.payCodeTypeId === 4).length > 0 &&
              employeeDetails.data.filter(x => x.payCodeTypeId !== 4).length === 0) {
              mode = 'View';
              ShowToast(
                'No Overtime Attendance has been submitted for ' + this.state?.selectedData
                  ?.find(em => em.key === 'employeeName')?.selected?.employeeName,
                toastType.INFO,
                5000,
                500);
            }
            if (employeeDetails.data?.length === 1) {
              payCodeList = (employeeDetails.data.find(x => x.payCodeTypeId === 4) || {}).billingAccountingAdjustment.filter(x => x.payCodeTypeId !== 1);
              payStatement = (employeeDetails.data?.find(x => x.payCodeTypeId === 4) || {}).billingAccountingAdjustment
                .find(y => parseFloat(y.reimbursementAmount) > 0 && payCodeList.find(py => py.payCodeId === y.payCodeId && py.payCodeTypeId === 4));
            } else {
              payCodeList = (employeeDetails.data.find(x => x.payCodeTypeId !== 4) || {}).billingAccountingAdjustment.filter(x => x.payCodeTypeId !== 1);
              payStatement = (employeeDetails.data?.find(x => x.payCodeTypeId === 4) || {}).billingAccountingAdjustment
                .find(y => parseFloat(y.reimbursementAmount) > 0 && payCodeList.find(py => py.payCodeId === y.payCodeId && py.payCodeTypeId === 2));
            }
          } if (allocationType === 'Property Billing') {
            payCodeList = employeeDetails.data.length === 1
              ? cloneDeep(((employeeDetails.data.find(x => x.payCodeTypeId === 4) || {}).billingAccountingAdjustment.filter(x => x.payCodeTypeId !== 1) || []))
              : cloneDeep(((employeeDetails.data.find(x => x.payCodeTypeId !== 4) || {}).billingAccountingAdjustment.filter(x => x.payCodeTypeId !== 1) || []));
            if (employeeDetails.data.length === 1) {
              payCodeList = payCodeList.map(x => { x.payCodeTypeId = 2; return x; });
            }
            payStatement = employeeDetails.data?.find(x => x.payCodeTypeId === 4)?.billingAccountingAdjustment
              .find(y => parseFloat(y.reimbursementAmount) > 0 && payCodeList.find(py => py.payCodeId === y.payCodeId && py.payCodeTypeId === 2));
          } else {
            payCodeList = [...((employeeDetails.data.find(x => x.payCodeTypeId !== 4) || {}).billingAccountingAdjustment.filter(x => x.payCodeTypeId !== 1) || [])];
            payStatement = employeeDetails.data?.find(x => x.payCodeTypeId === 4)?.billingAccountingAdjustment
              .find(y => parseFloat(y.reimbursementAmount) > 0 && payCodeList.find(py => py.payCodeId === y.payCodeId && py.payCodeTypeId === 2));
          }
          if (employeeId === 0) {
            employeeId = cellInfo.employeeId;
            const empObj = selectedData.find(x => x.key === 'employeeName');
            if (empObj === undefined || empObj.selected === undefined || empObj.selected.employeeId <= 0) {
              selectedData1.push({
                key: 'employeeName',
                selected: employeeMasterData.find(x => parseInt(x.employeeId) === parseInt(cellInfo.employeeId))
              });
            }
          }
          if (isClosed === true) {
            mode = 'View';
            ShowToast(
              "Selected pay period is closed. You can't adjust the values.",
              toastType.INFO,
              5000,
              500);
          } else if (payStatement === undefined) {
            mode = 'View';
            ShowToast(
              'There is no Paycode for adjustment.',
              toastType.INFO,
              5000,
              500);
          }
        } else {
          if (isClosed === true) {
            ShowToast(
              "Selected pay period is closed. You can't adjust the values.",
              toastType.INFO,
              5000,
              500);
          } else {
            ShowToast(
              'There is no Pay Data available for ' + this.state?.selectedData
                ?.find(em => em.key === 'employeeName')?.selected?.employeeName + ' from UltiPro for the pay cycle ' + periodStartDate + '-' + periodEndDate + '.',
              toastType.INFO,
              5000,
              500);
          }
        }
        employeeDetails.data = employeeDetails.data.map(x => {
          x.reimbursementAmount = x.reimbursementAmount < 0 ? 0 : x.reimbursementAmount;
          x.billingAccountingAdjustment = x.billingAccountingAdjustment.map(y => { y.reimbursementAmount = y.reimbursementAmount < 0 ? 0 : y.reimbursementAmount; return y; });
          return x;
        });
        let allPayCodeList = employeeDetails.data?.length > 1 ? (employeeDetails.data.find(x => x.payCodeTypeId !== 4 && x.isEditable !== true) || {}).billingAccountingAdjustment : [];
        if(allPayCodeList === undefined || allPayCodeList === null || allPayCodeList?.length === 0 ) {
          allPayCodeList = employeeDetails.data?.length > 1 ? (employeeDetails.data.find(x => x.payCodeTypeId !== 4) || {}).billingAccountingAdjustment : [];
        }

        this.setState({
          // allPayCodeList: employeeDetails.data?.length > 1 ? (employeeDetails.data.find(x => x.payCodeTypeId !== 4 && x.isEditable !== true) || {}).billingAccountingAdjustment : [],
          allPayCodeList: allPayCodeList,
          deletedRecord: [],
          //  marketMasterData: cloneDeep(originalMarketMasterData.filter(x => (employeeDetails.data.find(ey => ey.marketId === x.marketId) === undefined)) || []),
          selectedData: selectedData1,
          employeeDetails: employeeDetails.data,
          payCodeList,
          employeeConfiguration: employeeDetails.config,
          isInEditMode: true,
          updateData: cellInfo,
          mode: mode,
          radioValue: employeeDetails.data?.length > 1 ? ((employeeDetails.data.find(x => x.payCodeTypeId !== 4) || {}).splitType === null ? 'Amount Split' : (employeeDetails.data.find(x => x.payCodeTypeId !== 4) || {}).splitType) : 'Amount Split'
          //  IsSaved: (allocationType === 'Property' && employeeDetails.data?.length === 1)
        }, () => {
          if (employeeId > 0) {
            this.GetReimbursementAdjustmentDetail(periodStartDate, periodEndDate, employeeId);
          }
        });
      })
      .catch(() => {
        this.Clear();
      });
  }

  // Check whether pay cycle is open or closed
  isPayCycleOpen = (payPeriod) => {
    const { payCycleData } = this.state;
    const payCycle = payCycleData.find(x => x.payCycle === payPeriod);
    return payCycle !== undefined ? payCycle.isClosed : false;
  }

  // Render Edit/Update/Cancel action buttons for the records
  renderActionColumn = (cellInfo) => {
    return (
      <>
        {
          <>
            <Tooltip title="View Record">
              <IconButton
                aria-label={'refreshData'}
                size="small"
                onClick={() => {
                  if (this.state.isInEditMode === true) {
                    ShowToast('You can edit/view/delete one row at a time!', toastType.WARNING, 5000, 500);
                    return false;
                  } else {
                    this.EditRecord(cellInfo, 0, 'View');
                  }
                }}
              >
                <Visibility fontSize="small" size="small" />
              </IconButton>
            </Tooltip>
            { this.state.isEditable && !this.isPayCycleOpen(cellInfo.payPeriod)
              ? <>
                <Tooltip title="Edit Record">
                  <IconButton aria-label={'refreshData'} size="small" onClick={() => {
                    if (this.state.isInEditMode === true) {
                      ShowToast('You can edit/view/delete one row at a time!', toastType.WARNING, 5000, 500);
                      return false;
                    } else {
                      this.EditRecord(cellInfo);
                    }
                  }}>
                    <EditIcon fontSize="small" size="small" />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Delete Record">
                  <IconButton
                    aria-label={'refreshData'}
                    size="small"
                    onClick={() => {
                      if (this.state.isInEditMode === true) {
                        ShowToast('You can edit/view/delete one row at a time!', toastType.WARNING, 5000, 500);
                        return false;
                      } else {
                        this.DeleteRecord(cellInfo);
                      }
                    }}
                  >
                    <DeleteIcon fontSize="small" size="small" />
                  </IconButton>
                </Tooltip>
              </>
              : ''}
          </>
        }
      </>
    );
  };

  // Handle delete action
  DeleteRecord = (cellInfo) => {
    let popupMessage = '';
    const allocationType = this.state.allocationType;
    if (allocationType === 'Market') {
      popupMessage = <span>Do you want to clear billing/accounting adjustment data of <b>{cellInfo.employeeName}</b> for paycycle <b> {cellInfo.payPeriod}</b> for all markets?</span>;
    } else if (allocationType === 'Property Billing') {
      popupMessage = <span> Do you want to clear property billing adjustment data of < b > {cellInfo.employeeName}</b > for paycycle < b > {cellInfo.payPeriod}</b >?</span>;
    } else if (allocationType === 'Property OT') {
      popupMessage = <span>Do you want to clear property overtime adjustment data of <b>{cellInfo.employeeName}</b> for paycycle <b> {cellInfo.payPeriod}</b>?</span>;
    }
    this.setState({
      isPopupOpen: true,
      confirmationMessage: popupMessage, // <span>Do you want to clear billing/accounting adjustment data of <b>{cellInfo.employeeName}</b> for paycycle <b> {cellInfo.payPeriod}</b> for all markets?</span>,
      updateData: cellInfo
    }, () => { this.forceUpdate(); });
  }

  // Handle action on confirmation popup
  onPopupClickHandle = (isValid) => {
    if (isValid) {
      const adjustmentData = [];
      const data = this.state.updateData;
      data.statusId = 11;
      data.periodStartDate = this.state.periodStartDate;
      data.periodEndDate = this.state.periodEndDate;
      adjustmentData.push(data);
      this.setState({
        isPopupOpen: false,
        confirmationMessage: ''
      }, () => {
        this.SaveReimbursementAdjustment(adjustmentData, 1);
      });
    } else {
      this.setState({
        updateData: undefined,
        isPopupOpen: false,
        confirmationMessage: ''
      });
    }
  }

  // Render Table
  renderTableForm = (data) => {
    return this.renderTable(data);
  }

  // Save Reimbursement Adjustments
  SaveReimbursementAdjustment = (adjustmentData, isMessage = 0) => {
    const billingAdjustmentsDataStore = this.state.billingAdjustmentsData;
    const { periodStartDate, periodEndDate, selectedData, allocationType } = this.state;
    const selectedData1 = selectedData.filter(x => x.key !== 'employeeName');
    apiPut(API_URL.Employee.SaveReimbursementAdjustment, adjustmentData, {
      adjustmentType: allocationType
    }).then(({ data: response }) => {
      const msg = isMessage === 1 ? 'Record(s) deleted successfully.' : 'Record(s) updated successfully.';
      if (response.success === true) {
        ShowToast(
          msg,
          toastType.SUCCESS,
          5000,
          500
        );

        this._asyncRequest = apiBatchRequest([
          {
            url: API_URL.Employee.GetReimbursementAdjustmentDetail + '?periodStartDate=' + periodStartDate + '&periodEndDate=' + periodEndDate + '&adjustmentType=' + allocationType, // + '&EmployeeId=' + this.state.selectedEmployeeId,
            key: 'billingAdjustmentsData'
          }
        ])
          .then(({ billingAdjustmentsData }) => {
            this.setState({
              billingAdjustmentsData: billingAdjustmentsData.data || [],
              originalBillingAdjustmentsData: billingAdjustmentsData.data || [],
              configuration: billingAdjustmentsData.config || [],
              updateData: undefined,
              isPopupOpen: false,
              confirmationMessage: '',
              employeeDetails: [],
              payCodeList: [],
              employeeConfiguration: [],
              isInEditMode: false,
              radioValue: 'Amount Split',
              selectedData: selectedData1,
              reloadTable: !this.state.reloadTable,
              IsSaved: false,
              deletedRecord: []
            }, () => { this.forceUpdate(); });
          })
          .catch(() => {
            this._asyncRequest = null;
            this.setState({
              billingAdjustmentsData: billingAdjustmentsDataStore,
              updateData: undefined,
              isInEditMode: false,
              isPopupOpen: false,
              confirmationMessage: '',
              radioValue: 'Amount Split',
              IsSaved: false
            }, () => { this.forceUpdate(); });
          });
      } else {
        ShowToast(
          response.msg,
          toastType.ERROR,
          5000,
          500
        );
      }
    }).catch(() => {
      ShowToast(
        commonLabels.somethingWrong,
        toastType.ERROR,
        false,
        500
      );
      this.setState({ IsSaved: false });
    });
  }

  // Save Billing Adjustments
  SaveBillingAdjustment = () => {
    const { employeeDetails, radioValue, deletedRecord, allocationType } = this.state;
    let isInErrorState = false;
    employeeDetails.filter(x => x.payCodeTypeId !== 4).map(x => {
      if (allocationType === 'Market') {
        if (x.marketId <= 0 || x.marketName === undefined || x.marketName === null || x.marketName === '') {
          x.marketNameIsInErrorState = true;
          x.marketNameerrorMessage = 'Market field is required.';
          isInErrorState = true;
        } else {
          x.marketNameIsInErrorState = false;
          x.marketNameerrorMessage = '';
        }
        if (x.divisionId <= 0 || x.divisionId === undefined || x.division === null || x.division === '') {
          x.divisionIsInErrorState = true;
          x.divisionerrorMessage = 'Division field is required.';
          isInErrorState = true;
        } else {
          x.divisionIsInErrorState = false;
          x.divisionerrorMessage = '';
        }
        if (x.departmentId <= 0 || x.departmentId === undefined || x.departmentName === null || x.departmentName === '') {
          x.departmentNameIsInErrorState = true;
          x.departmentNameerrorMessage = 'Department field is required.';
          isInErrorState = true;
        } else {
          x.departmentNameIsInErrorState = false;
          x.departmentNameerrorMessage = '';
        }
      }
      if (allocationType === 'Property Billing') {
        if (x.propertyId <= 0 || x.propertyId === undefined || x.propertyId === null || x.propertyId === '') {
          x.propertyNameIsInErrorState = true;
          x.propertyNameerrorMessage = 'Property field is required.';
          isInErrorState = true;
        } else {
          x.propertyNameIsInErrorState = false;
          x.propertyNameerrorMessage = '';
        }
      }
      return x;
    });

    if (isInErrorState === true) {
      this.setState({
        employeeDetails: employeeDetails,
        IsSaved: false
      }, () => {
        this.forceUpdate();
      });
    } else {
      const mergedArray = [];
      const marketOrPropertyWiseGross = employeeDetails.find(x => x.payCodeTypeId === 4);
      employeeDetails.filter(x => x.payCodeTypeId !== 4).map(x => {
        x.billingAccountingAdjustment.map(y => {
          let adjustmentObj = [];
          adjustmentObj = y;
          adjustmentObj.reimbursementAmount = adjustmentObj.reimbursementAmount !== undefined && adjustmentObj.reimbursementAmount !== null && adjustmentObj.reimbursementAmount !== '' ? adjustmentObj.reimbursementAmount : 0;
          adjustmentObj.splitPercent = adjustmentObj.splitPercent !== undefined && adjustmentObj.splitPercent !== null && adjustmentObj.splitPercent !== '' ? adjustmentObj.splitPercent : 0;
          adjustmentObj.employeeId = x.employeeId;
          adjustmentObj.employeeName = x.employeeName;
          if (this.state.allocationType === 'Market') {
            adjustmentObj.marketId = x.marketId;
            adjustmentObj.marketName = x.marketName;
            adjustmentObj.divisionId = x.divisionId;
            adjustmentObj.division = x.division;
            adjustmentObj.departmentId = x.departmentId;
            adjustmentObj.departmentName = x.departmentName;
          }
          if (this.state.allocationType === 'Property Billing') {
            adjustmentObj.propertyId = x.propertyId;
            adjustmentObj.propertyName = x.propertyName;
            adjustmentObj.burdenRate = x.burdenRate;
          }
          adjustmentObj.allocationPercent = x.allocationPercent;
          adjustmentObj.adjustmentPercent = x.adjustmentPercent;
          adjustmentObj.grossAmount = x.grossAmount;
          adjustmentObj.periodEndDate = x.periodEndDate;
          adjustmentObj.periodStartDate = x.periodStartDate;
          adjustmentObj.splitType = radioValue;
          adjustmentObj.propertyId = x.propertyId;
          adjustmentObj.propertyName = x.propertyName;
          adjustmentObj.Multiplier = x.Multiplier;
          // adjustmentObj.PayRate = x.PayRate;
          mergedArray.push(adjustmentObj);
          return y;
        });

        return x;
      });
      const individualAmountRecord = mergedArray.filter(x => x.payCodeTypeId === 2);
      let message = '';
      if (marketOrPropertyWiseGross.billingAccountingAdjustment?.length > 0) {
        individualAmountRecord.map(x => {
          const total = individualAmountRecord.filter(y => y.payCodeId === x.payCodeId && y.payCode === x.payCode).reduce((total, obj) => obj.reimbursementAmount !== '' ? (parseFloat(obj.reimbursementAmount) + parseFloat(total)) : parseFloat(total), 0);
          const reimbursementAmount = marketOrPropertyWiseGross.billingAccountingAdjustment.filter(y => y.payCodeId === x.payCodeId && y.payCode === x.payCode).reduce((total, obj) => obj.reimbursementAmount !== '' ? (parseFloat(obj.reimbursementAmount) + parseFloat(total)) : parseFloat(total), 0);

          // if (reimbursementAmount.toFixed(4) !== parseFloat(total).toFixed(4)) {
          if (Number(parseFloat(total).toFixed(4)) > Number(parseFloat(reimbursementAmount).toFixed(4)) || (Number((parseFloat(reimbursementAmount).toFixed(4))) > 0 && Number(parseFloat(total).toFixed(4) <= 0))) {
            if (allocationType === 'Property OT' && Number(parseFloat(total).toFixed(4)) > Number(parseFloat(reimbursementAmount).toFixed(4))) {
              message = <span>Adjusted amount for paycode <b>{x.payCode}</b> should be less than or equal to amount <b>${reimbursementAmount}</b></span>;
            } else if (allocationType === 'Market') {
              message = <span>Adjusted amount for paycode <b>{x.payCode}</b> should be greater than $0 and less than or equal to amount <b>${reimbursementAmount}</b> from UltiPro.</span>;
            } else if (allocationType === 'Property Billing' && Number(parseFloat(total).toFixed(4)) > Number(parseFloat(reimbursementAmount).toFixed(4))) {
              message = <span>Adjusted amount for paycode <b>{x.payCode}</b> should be less than or equal to amount <b>${reimbursementAmount}</b> from UltiPro.</span>;
            }
          }
          return x;
        });
      }
      const lastArrayRecord = employeeDetails[employeeDetails?.length - 1];
      if (allocationType === 'Market' && lastArrayRecord !== undefined) {
        const duplicateRecords = employeeDetails.filter(x => x.employeeId === lastArrayRecord.employeeId && x.divisionId === lastArrayRecord.divisionId &&
          x.departmentId === lastArrayRecord.departmentId && x.marketId === lastArrayRecord.marketId);
        if (duplicateRecords !== undefined && duplicateRecords.length > 1) {
          message = lastArrayRecord.employeeName + ' amount already adjusted for the ' + lastArrayRecord.marketName + ' with ' + lastArrayRecord.division + ' and ' + lastArrayRecord.departmentName + '.';
          ShowToast(message, toastType.WARNING, 5000, 500);
        }
      }
      if (message !== '') {
        ShowToast(
          message,
          toastType.ERROR,
          5000,
          500);
        this.setState({ IsSaved: false });
      } else {
        if (this.state.allocationType === 'Market' || this.state.allocationType === 'Property Billing') {
          deletedRecord.filter(x => x.payCodeTypeId !== 4).map(x => {
            x.billingAccountingAdjustment.map(y => {
              let adjustmentObj = [];
              adjustmentObj = y;
              adjustmentObj.reimbursementAmount = adjustmentObj.reimbursementAmount !== undefined && adjustmentObj.reimbursementAmount !== null && adjustmentObj.reimbursementAmount !== '' ? adjustmentObj.reimbursementAmount : 0;
              adjustmentObj.splitPercent = adjustmentObj.splitPercent !== undefined && adjustmentObj.splitPercent !== null && adjustmentObj.splitPercent !== '' ? adjustmentObj.splitPercent : 0;
              adjustmentObj.employeeId = x.employeeId;
              adjustmentObj.employeeName = x.employeeName;
              if (this.state.allocationType === 'Market') {
                adjustmentObj.marketId = x.marketId;
                adjustmentObj.marketName = x.marketName;
                adjustmentObj.divisionId = x.divisionId;
                adjustmentObj.division = x.division;
                adjustmentObj.departmentId = x.departmentId;
                adjustmentObj.departmentName = x.departmentName;
              }
              if (this.state.allocationType === 'Property Billing') {
                adjustmentObj.propertyId = x.propertyId;
                adjustmentObj.propertyName = x.propertyName;
                adjustmentObj.burdenRate = x.burdenRate;
              }
              adjustmentObj.allocationPercent = x.allocationPercent;
              adjustmentObj.adjustmentPercent = x.adjustmentPercent;
              adjustmentObj.grossAmount = x.grossAmount;
              adjustmentObj.periodEndDate = x.periodEndDate;
              adjustmentObj.periodStartDate = x.periodStartDate;
              adjustmentObj.splitType = radioValue;
              adjustmentObj.statusId = 11;
              mergedArray.push(adjustmentObj);
              return y;
            });

            return x;
          });
        }
        this.SaveReimbursementAdjustment(mergedArray);
        this.setState({ IsSaved: false });
      }
    }
  }

  // Clear record data
  Clear = () => {
    this.setState({
      employeeDetails: [],
      payCodeList: [],
      employeeConfiguration: [],
      isInEditMode: false,
      radioValue: 'Amount Split',
      selectedData: this.state.selectedData.filter(x => x.key !== 'employeeName'),
      mode: '',
      deletedRecord: []
    }, () => this.onFilterChange(this.state.selectedData));
  }

  // Render table
  renderTable = (data) => {
    const { payCodeList } = this.state;
    const headerObj = [];
    const isEditable = cloneDeep((data.find(x => x.isEditable === true) || {})?.isEditable);
    if (this.state.radioValue === 'Amount Split') {
      headerObj.push({ renderColSpan: false });
    } else {
      headerObj.push({ renderColSpan: true });
      headerObj.push({ renderColSpan: false });
    }
    return (
      <TableContainer
        className={'sticky-wrapper'}
      >
        <Table
          id="gridTable" stickyHeader
          className='billingAdjustment'
          aria-labelledby="tableTitle"
          size={'small'}
          aria-label="sticky table"
        >
          <TableHead>
            {
              headerObj.map((masterHeaderObj, masterKeyIndex) => {
                return <TableRow key={masterKeyIndex}>
                  {isEditable === true && <TableCell>
                  </TableCell>}
                  {
                    billingAdjustmentColumn.map((x, index) => (
                      (x.hideWhen === undefined || x.hideWhen.find(hx => hx.key === x.hiddenKey) === undefined || (x.hideWhen.find(hx => hx.key === x.hiddenKey) !== undefined && x.hideWhen.find(hx => hx.key === x.hiddenKey && hx.value === this.state.allocationType) === undefined)) &&
                      <TableCell key={'th' + index} style={{ minWidth: x.minWidth }}>{masterHeaderObj.renderColSpan ? <>&nbsp;</> : getFormattedHeaders(x.name, x.dataFormat)}</TableCell>
                    ))
                  }
                  {
                    (
                      payCodeList?.map((x, index) => (
                        masterHeaderObj.renderColSpan || this.state.radioValue === 'Amount Split'
                          ? <>
                            <TableCell className={this.state.radioValue === 'Amount Split'
                              ? 'pay-code amount-split-col text-right-alignment'
                              : ' pay-code percent-split-col percent-text-alignment'}
                              colSpan={this.state.radioValue === 'Amount Split' ? 1 : 2}
                              key={'th' + index}
                              style={{ minWidth: '100px' }}>
                              {getFormattedHeaders(x.payCode, x.dataFormat)}
                            </TableCell>
                          </>
                          : <>
                            <TableCell className={this.state.radioValue === 'Amount Split'
                              ? 'pay-code amount-split-col'
                              : ' pay-code percent-split-col text-right-alignment '}
                              key={'th' + index}
                              style={{ minWidth: '100px' }}
                            >
                              {getFormattedHeaders(this.state.allocationType === 'Property OT' && !x.payCode?.includes('Amount') ? 'Hour' : 'Amount', x.dataFormat)}
                            </TableCell>
                            {
                              this.state.radioValue === 'Percent Split' &&
                              <TableCell className={this.state.radioValue === 'Amount Split'
                                ? 'pay-code amount-split-col'
                                : ' pay-code percent-split-col text-right-alignment'}
                                key={'th' + index}
                                style={{ minWidth: '100px' }}
                              >
                                {getFormattedHeaders('Split %', x.dataFormat)}
                              </TableCell>
                            }
                          </>
                      )))
                  }
                </TableRow>;
              })
            }
          </TableHead>
          <TableBody>
            {this.renderTableCell(data, payCodeList, [], isEditable)}
          </TableBody>
        </Table>
      </TableContainer >
    );
  }

  // Apply Number format on given value
  formatNumber = (value) => {
    // const regex = new RegExp('^0+(?!$)', 'g');
    // // Replaces the matched
    // // value with given string
    // value = value.replaceAll(regex, '');
    // if (value?.indexOf('.') === 0) {
    //   return '0' + value;
    // }
    const last = value?.charAt(value?.length - 1);
    if (last === '.' || last === '0' || (/^0*$/.test(value))) { return value; } else { return parseFloat(value); }
  }

  // Handle amount values change event
  onChangeValues = (value, fieldName, masterKey, childKey, obj) => {
    const { employeeDetails, radioValue, allocationType } = this.state;
    const marketOrPropertyWiseGross = employeeDetails.find(x => x.payCodeTypeId === 4);
    const valuePattern = RegExp(
      '^\\s*((\\d+(\\.\\d{0,2})?)|((\\d*(\\.\\d{1,4}))))\\s*$'
    );
    employeeDetails[masterKey].billingAccountingAdjustment[childKey][fieldName] = isNaN(value) || !valuePattern.test(value) || value === '' ? 0 : this.formatNumber(value);

    if (allocationType === 'Property OT') {
      employeeDetails[masterKey].billingAccountingAdjustment[childKey][fieldName] = isNaN(value) || !valuePattern.test(value) || value === '' ? 0 : this.formatNumber(value);

      const paycode = obj.payCode;
      const associatePayCode = marketOrPropertyWiseGross.billingAccountingAdjustment.find(x => x.payCodeId === obj.payCodeId && x.payCode !== obj.payCode)?.payCode;

      const changeInAmount = paycode?.includes('Amount');
      const isChangesForOT = paycode?.includes('OVERTIME');
      let totalHrs, totalAmount;

      if (isChangesForOT) {
        totalHrs = parseFloat(marketOrPropertyWiseGross.billingAccountingAdjustment.find(x => x.payCode === 'OVERTIME').reimbursementAmount);
        totalAmount = parseFloat(marketOrPropertyWiseGross.billingAccountingAdjustment.find(x => x.payCode === 'OVERTIME Amount').reimbursementAmount);
      } else {
        totalHrs = parseFloat(marketOrPropertyWiseGross.billingAccountingAdjustment.find(x => x.payCode === 'ADDL REG').reimbursementAmount);
        totalAmount = parseFloat(marketOrPropertyWiseGross.billingAccountingAdjustment.find(x => x.payCode === 'ADDL REG Amount').reimbursementAmount);
      }

      const amountPerHour = isNaN(totalAmount / totalHrs) ? 0 : (totalAmount / totalHrs);

      if (radioValue === 'Percent Split') {
        let valueTobeUpdate = 0;
        if (changeInAmount) {
          (employeeDetails[masterKey].billingAccountingAdjustment.filter(x => x.payCode === associatePayCode)).forEach(element => {
            valueTobeUpdate = parseFloat(parseFloat(value) * totalHrs / 100).toFixed(4);
            element.reimbursementAmount = isNaN(valueTobeUpdate) ? 0 : valueTobeUpdate;
            element.splitPercent = parseFloat(value).toFixed(4);
          });
          (employeeDetails[masterKey].billingAccountingAdjustment.filter(x => x.payCode === paycode)).forEach(element => {
            element.reimbursementAmount = ((parseFloat(value) * totalAmount) / 100).toFixed(4);
          });
        } else {
          (employeeDetails[masterKey].billingAccountingAdjustment.filter(x => x.payCode === associatePayCode)).forEach(element => {
            valueTobeUpdate = parseFloat(parseFloat(value) * totalAmount / 100).toFixed(4);
            element.splitPercent = parseFloat(value).toFixed(4);
            element.reimbursementAmount = isNaN(valueTobeUpdate) ? 0 : valueTobeUpdate;
          });
          (employeeDetails[masterKey].billingAccountingAdjustment.filter(x => x.payCode === paycode)).forEach(element => {
            element.reimbursementAmount = ((parseFloat(value) * totalHrs) / 100).toFixed(4);
          });
        }
      } else if (radioValue === 'Amount Split') {
        const fieldTotal = parseFloat(marketOrPropertyWiseGross.billingAccountingAdjustment.find(x => x.payCode === paycode)[fieldName]).toFixed(4);
        const associateFieldTotal = parseFloat(marketOrPropertyWiseGross.billingAccountingAdjustment.find(x => x.payCode === associatePayCode)[fieldName]).toFixed(4);
        let amount, hours;

        if (changeInAmount) {
          amount = fieldTotal;
          hours = associateFieldTotal;
        } else {
          amount = associateFieldTotal;
          hours = fieldTotal;
        }

        let valueTobeUpdate = 0;
        let splitPercent = 0;
        if (changeInAmount) {
          (employeeDetails[masterKey].billingAccountingAdjustment.filter(x => x.payCode === associatePayCode)).forEach(element => {
            if (amountPerHour === 0) {
              valueTobeUpdate = 0;
              element.reimbursementAmount = isNaN(valueTobeUpdate) ? 0 : valueTobeUpdate;
              if (radioValue === 'Amount Split') {
                element.splitPercent = value === 0 ? 0 : (parseFloat(value / totalAmount) * 100).toFixed(4);
                splitPercent = element.splitPercent;
              } else {
                element.reimbursementAmount = isNaN(valueTobeUpdate) ? 0 : valueTobeUpdate;
              }
            } else {
              valueTobeUpdate = parseFloat(parseFloat(value) / amountPerHour).toFixed(4);
              element.reimbursementAmount = isNaN(valueTobeUpdate) ? 0 : valueTobeUpdate;
              if (radioValue === 'Amount Split') {
                // element.splitPercent = element.reimbursementAmount === 0 ? 0 : Math.round(parseFloat(element.reimbursementAmount / hours) * 100);
                element.splitPercent = element.reimbursementAmount === 0 ? 0 : (parseFloat(element.reimbursementAmount / totalHrs) * 100).toFixed(4);
                splitPercent = element.splitPercent;
              } else {
                element.reimbursementAmount = isNaN(valueTobeUpdate) ? 0 : valueTobeUpdate;
              }
            }
          });
          (employeeDetails[masterKey].billingAccountingAdjustment.filter(x => x.payCode === paycode)).forEach(element => {
            element.splitPercent = splitPercent;
          });
        } else {
          let splitPercent;
          (employeeDetails[masterKey].billingAccountingAdjustment.filter(x => x.payCode === associatePayCode)).forEach(element => {
            if (amountPerHour === 0) {
              valueTobeUpdate = 0;
              element.reimbursementAmount = isNaN(valueTobeUpdate) ? 0 : valueTobeUpdate;
              if (radioValue === 'Amount Split') {
                element.splitPercent = value === 0 ? 0 : (parseFloat(value / totalHrs) * 100).toFixed(4);
                splitPercent = element.splitPercent;
              } else {
                element.reimbursementAmount = isNaN(valueTobeUpdate) ? 0 : valueTobeUpdate;
              }
            } else {
              valueTobeUpdate = parseFloat(parseFloat(value) * amountPerHour).toFixed(4);
              element.reimbursementAmount = isNaN(valueTobeUpdate) ? 0 : valueTobeUpdate;
              if (radioValue === 'Amount Split') {
                element.splitPercent = parseFloat(element.reimbursementAmount) === 0 ? 0 : (parseFloat(element.reimbursementAmount / totalAmount) * 100).toFixed(4);
                splitPercent = element.splitPercent;
              } else {
                element.reimbursementAmount = isNaN(valueTobeUpdate) ? 0 : valueTobeUpdate;
              }
            }
          });
          (employeeDetails[masterKey].billingAccountingAdjustment.filter(x => x.payCode === paycode)).forEach(element => {
            element.splitPercent = splitPercent;
          });
        }
      }
    } else {
      if (radioValue === 'Amount Split') {
        employeeDetails[masterKey].billingAccountingAdjustment.map(x => {
          const grossReimbursement = parseFloat((marketOrPropertyWiseGross?.billingAccountingAdjustment.find(y => y.payCodeTypeId === 4 && y.payCodeId === x.payCodeId) || {}).reimbursementAmount);
          x.splitPercent = grossReimbursement > 0 ? ((parseFloat(x.reimbursementAmount) / grossReimbursement) * 100).toFixed(4) : 0;
          x.splitPercent = isNaN(x.splitPercent) ? 0 : x.splitPercent;
          return x;
        });
      } else {
        employeeDetails[masterKey].billingAccountingAdjustment.map(x => {
          const grossReimbursement = parseFloat((marketOrPropertyWiseGross?.billingAccountingAdjustment.find(y => y.payCodeTypeId === 4 && y.payCodeId === x.payCodeId) || {}).reimbursementAmount);
          x.reimbursementAmount = grossReimbursement > 0 ? ((parseFloat(x.splitPercent) / 100) * grossReimbursement).toFixed(4) : 0;
          x.reimbursementAmount = isNaN(x.reimbursementAmount) ? 0 : x.reimbursementAmount;
          return x;
        });
      }
      if (allocationType === 'Market') {
        const calculatedGross = this.calculateGross(employeeDetails[masterKey], employeeDetails[masterKey].grossAmount);

        if (parseFloat(marketOrPropertyWiseGross?.grossAmount) > 0 || (marketOrPropertyWiseGross?.billingAccountingAdjustment?.find(x => (x.payCodeId === 10 || x.payCodeId === 15) && x.reimbursementAmount > 0))) {
          const marketWiseCalculatedGross = this.calculateGross(marketOrPropertyWiseGross, marketOrPropertyWiseGross?.grossAmount, true);
          employeeDetails[masterKey].adjustmentPercent = ((parseFloat(calculatedGross) / parseFloat(marketWiseCalculatedGross)) * 100).toFixed(4);
          employeeDetails[masterKey].adjustmentPercent = (isNaN(employeeDetails[masterKey].adjustmentPercent) || employeeDetails[masterKey].adjustmentPercent) < 0 ? 0 : employeeDetails[masterKey].adjustmentPercent;

          employeeDetails.filter(x => x.divisionId !== employeeDetails[masterKey].divisionId && x.payCodeTypeId !== 4).map(x => {
            const calculatedGross = this.calculateGross(x, x.grossAmount);
            const marketWiseCalculatedGross = this.calculateGross(marketOrPropertyWiseGross, marketOrPropertyWiseGross?.grossAmount, true);
            x.adjustmentPercent = ((parseFloat(calculatedGross) / parseFloat(marketWiseCalculatedGross)) * 100).toFixed(4);
            x.adjustmentPercent = (isNaN(x.adjustmentPercent) || x.adjustmentPercent < 0) ? 0 : x.adjustmentPercent;
            return x;
          });
        }

        employeeDetails[masterKey].billingAccountingAdjustment.filter(x => x.payCodeTypeId === 3).map(x => {
          x.reimbursementAmount = parseFloat(employeeDetails[masterKey].adjustmentPercent) > 0
            ? ((parseFloat((marketOrPropertyWiseGross?.billingAccountingAdjustment.find(y => y.payCodeTypeId === 4 && y.payCodeId === x.payCodeId) || {}).reimbursementAmount) *
              parseFloat(employeeDetails[masterKey].adjustmentPercent)) / 100).toFixed(4)
            : 0;
          x.reimbursementAmount = isNaN(x.reimbursementAmount) ? 0 : x.reimbursementAmount;

          if (parseFloat(employeeDetails[masterKey].adjustmentPercent) > 0) {
            const grossReimbursement = parseFloat((marketOrPropertyWiseGross?.billingAccountingAdjustment.find(y => y.payCodeTypeId === 4 && y.payCodeId === x.payCodeId) || {}).reimbursementAmount);
            x.splitPercent = grossReimbursement > 0
              ? ((parseFloat(x.reimbursementAmount) / grossReimbursement) * 100).toFixed(4)
              : 0;
          } else {
            x.splitPercent = 0;
          }

          x.splitPercent = isNaN(x.splitPercent) ? 0 : x.splitPercent;
          return x;
        });
      }
    }
    this.setState({ employeeDetails }, () => {
      this.forceUpdate();
    });
  }

  // Calculate gross amount 
  calculateGross = (data, grossAmount, isTotalRow) => {
    return (data.billingAccountingAdjustment
      .filter(x => ((x.payCodeTypeId === 2 || x.payCodeTypeId === 1) || (
        isTotalRow === true && (this.state.allPayCodeList || []).find(py => py.payCodeId === x.payCodeId && (py.payCodeTypeId === 2 || py.payCodeTypeId === 1))
      ))).reduce((total, obj) => obj.reimbursementAmount !== '' ? (parseFloat(obj.reimbursementAmount) + parseFloat(total)) : parseFloat(total), 0));
  }

  // Handle drop down value change event
  onDropDownChanges = (value, index, config, data) => {
    const { employeeDetails, marketMasterData, originalPropertyMasterData, allocationType, billingAdjustmentColumn } = this.state;

    employeeDetails[index][config.key] = value;
    employeeDetails[index][config.idKey] = (data?.find(x => x[config.key] === value) || {})[config.idKey];

    if (value !== undefined && value !== null && value !== '') {
      employeeDetails[index][config.key + 'IsInErrorState'] = false;
      employeeDetails[index][config.key + 'errorMessage'] = '';
    } else {
      employeeDetails[index][config.key + 'IsInErrorState'] = true;
      employeeDetails[index][config.key + 'errorMessage'] = config.name + ' field is required.';
    }
    this.setState({ employeeDetails }, () => {
      this.forceUpdate();
    });
  }

  // Remove adjustment record
  removeAdjustment = (obj, index) => {
    const { employeeDetails, deletedRecord } = this.state;
    deletedRecord.push(obj);
    employeeDetails.splice(index, 1);
    this.setState({ employeeDetails: employeeDetails, deletedRecord }, () => { this.forceUpdate(); });
  }

  // Render cells in table
  renderTableCell = (
    groupedData,
    payCodeList,
    tableCell = [],
    isEditable = false
  ) => {
    const EditSource = [];
    EditSource.push(
      { key: 'originalMarketData', data: this.state.originalMarketMasterData },
      { key: 'originalPropertyMasterData', data: this.state.originalPropertyMasterData },
      { key: 'originalDivisionData', data: this.state.originalDivisionData },
      { key: 'originalDepartmentData', data: this.state.originalDepartmentData }
    );
    groupedData.forEach((d, i) => {
      tableCell.push(
        <TableRow
          key={i}
          className={
            i % 2 === 0
              ? ' evenRow'
              : ' oddRow'
          }
        >
          {isEditable === true && <TableCell>
            {
              d.isEditable === true && this.state.mode !== 'View'
                ? <Tooltip title="Remove">
                  <IconButton
                    aria-label={'refreshData'}
                    size="small"
                    onClick={() => { }}
                  >
                    <ClearIcon
                      fontSize="small"
                      size="small"
                      onClick={() => {
                        this.removeAdjustment(d, i);
                      }
                      }
                    />
                  </IconButton>
                </Tooltip>

                : ''
            }
          </TableCell>}
          {
            billingAdjustmentColumn.map((x, index) => (

              (x.hideWhen === undefined || (x.hideWhen.find(hx => hx.key === x.hiddenKey && hx.value === this.state.allocationType)) === undefined) &&
              <TableCell key={i + index} style={{ minWidth: x.minWidth }}>
                {
                  d.isEditable === true && (x.isEditable === true) && this.state.mode !== 'View'
                    ? <>
                      <Autocomplete
                        blurOnSelect
                        id="tags-standard"
                        className="editable"
                        error={d[x.key + 'IsInErrorState']}
                        helperText={d[x.key + 'errorMessage']}
                        onChange={(e, val) => this.onDropDownChanges(val, i, x, x.ignoreFilter === true
                          ? EditSource.find((edx) => edx.key === x.sourceData)?.data
                          : x.cascaded !== undefined && x.cascaded1 !== undefined
                            ? EditSource.find((edx) => edx.key === x.sourceData)?.data?.filter(sx => sx[x.idKey] === d[x.idKey] || (this.state.employeeDetails.find(ey => ey[x.cascaded] === d[x.cascaded] && ey[x.cascaded1] === d[x.cascaded1] && ey[x.idKey] === sx[x.idKey]) === undefined)) || []
                            : EditSource.find((edx) => edx.key === x.sourceData)?.data?.filter(sx => sx[x.idKey] === d[x.idKey] || (this.state.employeeDetails.find(ey => ey[x.idKey] === sx[x.idKey]) === undefined)) || [])}
                        options={x.ignoreFilter === true
                          ? (EditSource.find((edx) => edx.key === x.sourceData)?.data?.map((option) => option[x.key]))
                          : x.cascaded !== undefined && x.cascaded1 !== undefined
                            ? (EditSource.find((edx) => edx.key === x.sourceData)?.data?.filter(sx => sx[x.idKey] === d[x.idKey] || (this.state.employeeDetails.find(ey => ey[x.cascaded] === d[x.cascaded] && ey[x.cascaded1] === d[x.cascaded1] && ey[x.idKey] === sx[x.idKey]) === undefined)) || []).map((option) => option[x.key])
                            : (EditSource.find((edx) => edx.key === x.sourceData)?.data?.filter(sx => sx[x.idKey] === d[x.idKey] || (this.state.employeeDetails.find(ey => ey[x.idKey] === sx[x.idKey]) === undefined)) || []).map((option) => option[x.key])}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="standard"
                            error={d[x.key + 'IsInErrorState']}
                            helperText={d[x.key + 'errorMessage']}
                            required
                            className="editable"
                          />
                        )}
                        value={d[x.key]}
                      />
                    </>

                    : <>
                      {x?.hideWhen?.find(z => z.key === 'payCodeTypeId')?.value === d.payCodeTypeId && d.isEditable !== true &&
                        (d[x.key] === null
                          ? 'NA'
                          : x.isRound ? getFormattedStringValues((d[x.key]), x.dataFormat, d.payCodeTypeId) : getFormattedStringValues(x.sumOfAdjustableGross ? this.calculateGross(d, d[x.key], true) : d[x.key], x.dataFormat, d.payCodeTypeId))}
                      {x.showWhen !== undefined && x.showWhen.find(z => z.key === 'payCodeTypeId')?.value !== d.payCodeTypeId &&
                        (d[x.key] === null
                          ? 'NA'
                          : getFormattedStringValues(x.sumOfAdjustableGross ? this.calculateGross(d, d[x.key]) : d[x.key], x.dataFormat, d.payCodeTypeId))}
                    </>
                }
              </TableCell>

            ))
          }
          {
            payCodeList.map((x, payCodeIndex) => {
              return this.renderDynamicColumn(d, i, x);
            })
          }
        </TableRow>
      );
    });
    return tableCell;
  };

  // Render columns dynamically based on conditions
  renderDynamicColumn = (d, i, y) => {
    const payCodeData = d.billingAccountingAdjustment.find(x => x.payCodeId === y.payCodeId && x.payCode === y.payCode);
    console.log(payCodeData);
    const index = d.billingAccountingAdjustment.findIndex(x => x.payCodeId === y.payCodeId && x.payCode === y.payCode);
    let grossPayCodeAmount = 0;
    if (this.state.allocationType === 'Market' || this.state.allocationType === 'Property Billing') {
      let amtSplit = false;
      grossPayCodeAmount = parseFloat(((this.state.employeeDetails.find(x => x.payCodeTypeId === 4) || {})
        .billingAccountingAdjustment?.find(x => x.payCodeTypeId === 4 && x.payCodeId === y.payCodeId) || {}).reimbursementAmount);
      if (this.state.radioValue === 'Amount Split') {
        amtSplit = true;
      }

      if (payCodeData !== undefined && payCodeData !== null && payCodeData !== '') {
        return (<>
          {
            payCodeData.payCodeTypeId === 2 && grossPayCodeAmount > 0 && this.state.mode !== 'View'
              ? payCodeListColumn.map((z, payCodeIndex) => {
                return (z.showWhen.value === this.state.radioValue || (amtSplit === true && z.key !== 'splitPercent')) &&
                  <TableCell className={z.className} key={i + index + payCodeIndex} style={{ minWidth: '100px' }}>
                    {
                      z.hideWhen.value === this.state.radioValue
                        ? <>
                          <TextField
                            value={payCodeData[z.key]}
                            margin="normal"
                            size="small"
                            color="primary"
                            className="editable amount-text"
                            onChange={(e) => this.isNumberKey(e) ? this.onChangeValues(e.target.value, z.key, i, index, payCodeData) : ''}
                            InputProps={z.appendText
                              ? {
                                endAdornment: <InputAdornment position="end"><span style={{ fontSize: '13px', color: '#B1B3B3' }}>%</span></InputAdornment>
                              }
                              : {
                                startAdornment: <InputAdornment position="end"><span style={{ fontSize: '13px', color: '#B1B3B3' }}>$</span></InputAdornment>
                              }}
                          />
                        </>
                        : payCodeData[z.key] === null ? 'NA' : (getFormattedStringValues(payCodeData[z.key], z.dataFormat, payCodeData.payCodeTypeId))

                    }
                  </TableCell>;
              })
              : payCodeListColumn.map((z, payCodeIndex) => {
                return (z.showWhen.value === this.state.radioValue || (amtSplit === true && z.key !== 'splitPercent')) &&
                  <TableCell className={z.className} key={i + index + payCodeIndex} style={{ minWidth: '100px' }}>
                    {
                      payCodeData[z.key] === null ? 'NA' : (getFormattedStringValues(payCodeData[z.key], z.dataFormat, payCodeData.payCodeTypeId))
                    }
                  </TableCell>;
              })
          }
        </>);
      } else {
        return <TableCell></TableCell>;
      }
    } else {
      let amtSplit = false;
      grossPayCodeAmount = parseFloat(((this.state.employeeDetails.find(x => x.payCodeTypeId === 4) || {})
        .billingAccountingAdjustment.find(x => x.payCodeTypeId === 4 && x.payCodeId === y.payCodeId && x.payCode === y.payCode) || {}).reimbursementAmount);
      if (this.state.radioValue === 'Amount Split') {
        amtSplit = true;
      }
      if (payCodeData !== undefined && payCodeData !== null && payCodeData !== '') {
        return (<>
          {
            payCodeData.payCodeTypeId === 2 && grossPayCodeAmount > 0 && this.state.mode !== 'View'
              ? overtimeListColumn.map((z, payCodeIndex) => {
                return (z.showWhen.value === this.state.radioValue || (amtSplit === true && z.key !== 'splitPercent')) && <TableCell className={z.className} key={i + index + payCodeIndex}>
                  {
                    z.hideWhen.value === this.state.radioValue
                      ? <>
                        <TextField
                          value={payCodeData[z.key]}
                          margin="normal"
                          size="small"
                          color="primary"
                          className="editable amount-text"
                          onChange={(e) => this.isNumberKey(e) ? this.onChangeValues(e.target.value, z.key, i, index, payCodeData) : ''}
                          InputProps={z.appendText
                            ? {
                              endAdornment: <InputAdornment position="end"><span style={{ fontSize: '13px', color: '#B1B3B3' }}>%</span></InputAdornment>
                            }
                            : (payCodeData.payCode?.includes('Amount')
                              ? {
                                startAdornment: <InputAdornment position="end"><span style={{ fontSize: '13px', color: '#B1B3B3' }}>$</span></InputAdornment>
                              }
                              : {
                                endAdornment: <InputAdornment position="end"><span style={{ fontSize: '13px', color: '#B1B3B3' }}>hr</span></InputAdornment>
                              })}
                        />
                      </>
                      : amtSplit === true && z.key === 'splitPercent'
                        ? ''
                        : payCodeData[z.key] === null
                          ? 'NA'
                          : (getFormattedStringValues(parseFloat(isNaN(payCodeData[z.key]) ? 0 : payCodeData[z.key]).toFixed(4).toLocaleLowerCase(),
                            (payCodeData.payCode?.includes('Amount') && z.key !== 'splitPercent'
                              ? 'MoneyDecimal'
                              : z.dataFormat),
                            payCodeData.payCodeTypeId,
                            (payCodeData.payCode?.includes('Amount') ? '$' : 'hr')))
                  }
                </TableCell>;
              })
              : overtimeListColumn.map((z, payCodeIndex) => {
                return (z.showWhen.value === this.state.radioValue || (amtSplit === true && z.key !== 'splitPercent')) && <TableCell className={z.className} key={i + index + payCodeIndex}>
                  {
                    amtSplit === true && z.key === 'splitPercent'
                      ? ''
                      : payCodeData[z.key] === null
                        ? 'NA'
                        : (getFormattedStringValues(parseFloat(isNaN(payCodeData[z.key]) ? 0 : payCodeData[z.key]).toFixed(4).toLocaleLowerCase(),
                          (payCodeData.payCode?.includes('Amount') && z.key !== 'splitPercent'
                            ? 'MoneyDecimal'
                            : z.dataFormat),
                          payCodeData.payCodeTypeId,
                          (payCodeData.payCode?.includes('Amount') ? '$' : 'hr')))
                  }
                </TableCell>;
              })
          }
        </>);
      } else {
        return <TableCell></TableCell>;
      }
    }
  }

  // Handle radio button change event
  handleChange = (e) => {
    this.setState({ radioValue: e.target.value });
  }

  // check whether input value is number
  isNumberKey = (evt) => {
    if (evt.target.value === '') {
      return true;
    } else {
      const numericInput = new RegExp(
        '^\\s*((\\d+(\\.\\d{0,2})?)|((\\d*(\\.\\d{1,4}))))\\s*$'
      ); // '/^[0-9\b]+$/');
      return numericInput.test(evt.target.value);
    }
  }

  // Add new record
  AddNewItem = () => {
    const { employeeDetails, periodStartDate, periodEndDate, allocationType } = this.state;
    let isInErrorState = false;
    employeeDetails.filter(x => x.payCodeTypeId !== 4).map(x => {
      if (allocationType === 'Market') {
        if (x.marketId <= 0 || x.marketName === undefined || x.marketName === null || x.marketName === '') {
          x.marketNameIsInErrorState = true;
          x.marketNameerrorMessage = 'Market field is required.';
          isInErrorState = true;
        } else {
          x.marketNameIsInErrorState = false;
          x.marketNameerrorMessage = '';
        }
        if (x.divisionId <= 0 || x.divisionId === undefined || x.division === null || x.division === '') {
          x.divisionIsInErrorState = true;
          x.divisionerrorMessage = 'Division field is required.';
          isInErrorState = true;
        } else {
          x.divisionIsInErrorState = false;
          x.divisionerrorMessage = '';
        }
        if (x.departmentId <= 0 || x.departmentId === undefined || x.departmentName === null || x.departmentName === '') {
          x.departmentNameIsInErrorState = true;
          x.departmentNameerrorMessage = 'Department field is required.';
          isInErrorState = true;
        } else {
          x.departmentNameIsInErrorState = false;
          x.departmentNameerrorMessage = '';
        }
      }
      if (allocationType === 'Property Billing') {
        if (x.propertyId <= 0 || x.propertyId === undefined || x.propertyId === null || x.propertyId === '') {
          x.propertyNameIsInErrorState = true;
          x.propertyNameerrorMessage = 'Property field is required.';
          isInErrorState = true;
        } else {
          x.propertyNameIsInErrorState = false;
          x.propertyNameerrorMessage = '';
        }
      }
      return x;
    });
    if (isInErrorState === true) {
      this.setState({ employeeDetails }, () => {
        this.forceUpdate();
      });
    } else {
      const lastArrayRecord = employeeDetails[employeeDetails?.length - 1];
      let message = '';
      if (allocationType === 'Market' && lastArrayRecord !== undefined) {
        const duplicateRecords = employeeDetails.filter(x => x.employeeId === lastArrayRecord.employeeId && x.divisionId === lastArrayRecord.divisionId &&
          x.departmentId === lastArrayRecord.departmentId && x.marketId === lastArrayRecord.marketId);
        if (duplicateRecords !== undefined && duplicateRecords.length > 1) {
          message = lastArrayRecord.employeeName + ' amount already adjusted for the ' + lastArrayRecord.marketName + ' with ' + lastArrayRecord.division + ' and ' + lastArrayRecord.departmentName + '.';

          ShowToast(message, toastType.WARNING, 5000, 500);

          return false;
        }
      }
      if (message === '') {
        const empInfo = employeeDetails.length === 1 ? cloneDeep(employeeDetails.find(x => x.payCodeTypeId === 4) || {}) : cloneDeep(employeeDetails.find(x => x.payCodeTypeId !== 4) || {});
        const newBilling = cloneDeep(empInfo.billingAccountingAdjustment || []);
        const billingAccountingAdjustment = cloneDeep(newBilling.map(py => {
          py.reimbursementAmount = 0;
          py.splitPercent = 0;
          py.grossAmount = 0;
          if (allocationType === 'Market') {
            py.marketReimbursementAdjustmentId = 0;
          }

          if (allocationType === 'Property Billing') {
            py.propertyReimbursementAdjustmentId = 0;
            if (employeeDetails.length === 1) {
              py.payCodeTypeId = 2;
            }
          }
          return py;
        }) || []);

        const obj = {
          employeeId: empInfo.employeeId,
          employeeName: empInfo.employeeName,
          marketId: 0,
          marketName: '',
          divisionId: 0,
          division: '',
          departmentId: 0,
          departmentName: '',
          propertyId: 0,
          propertyName: '',
          burdenRate: empInfo.burdenRate,
          allocationPercent: 0,
          adjustmentPercent: 0,
          grossAmount: 0,
          periodEndDate: periodEndDate,
          periodStartDate: periodStartDate,
          isEditable: true,
          billingAccountingAdjustment
        };
        employeeDetails.push(obj);
        this.setState({ employeeDetails }, () => {
          this.forceUpdate();
        });
      }
    }
  }

  // Navigate to Close Pay Period page
  goToPayPeriodPage = () => {
    this.props.history.push('/closePayPeriod?isBack=' + true);
  }

  // Render components based on conditions
  render() {
    const {
      employeeMasterData,
      marketMasterData,
      selectedData,
      configuration,
      payCycleData,
      defaultSelectedData,
      billingAdjustmentsData,
      reloadTable,
      isPopupOpen,
      confirmationMessage,
      employeeDetails,
      radioValue,
      mode,
      IsSaved
    } = this.state;
    const allocationTypeRadio = [];
    allocationTypeRadio.push({ value: 'Market', title: 'Market Adjustment' });
    allocationTypeRadio.push({ value: 'Property OT', title: 'Property OT Adjustment' });
    allocationTypeRadio.push({ value: 'Property Billing', title: 'Property Billing Adjustment' });
    const billingSplitTypeRadio = [];
    billingSplitTypeRadio.push({ value: 'Amount Split', title: 'Amount Split' });
    billingSplitTypeRadio.push({ value: 'Percent Split', title: 'Percent Split' });

    return (
      <>
        {isPopupOpen && (
          <ConfirmDialog
            IsOpen={isPopupOpen}
            Message={confirmationMessage}
            OnHandelClick={(isValid) => {
              if (isValid) {
                this.onPopupClickHandle(isValid);
              } else {
                this.onPopupClickHandle(isValid);
              }
            }}
            AgreeText="Yes"
            DisAgreeText="No"
          />
        )}
        <PageHeader title="Billing/Accounting Adjustments"></PageHeader>
        <div className="row start-xs end-xs">
          <div className="col-xs-auto backpage" onClick={(e) => this.goToPayPeriodPage()}>
            Go To Close Pay Period
          </div>
        </div>
        <PageFilter
          autoFilter={false}
          filterAlwaysVisible={true}
          onFilterChanged={this.onFilterChange}
          hidePanel={true}
          filterConfig={[
            {
              type: controlType.RadioButton,
              key: 'allocationType',
              options: allocationTypeRadio,
              placeholder: 'Search Property',
              title: 'Allocation Type',
              isHandleClick: true,
              gridColumn: 4
            },
            // {
            //   multiple: false,
            //   type: controlType.DropDown,
            //   source: marketMasterData,
            //   key: 'marketName',
            //   placeholder: 'Search Market',
            //   title: 'Market',
            //   disableClearable: false
            // },
            {
              multiple: false,
              type: controlType.DropDown,
              source: employeeMasterData,
              key: 'employeeName',
              placeholder: 'Search Employee',
              title: 'Employee',
              disableClearable: false
            },
            {
              multiple: false,
              type: controlType.DropDown,
              source: payCycleData,
              key: 'payCycle',
              placeholder: 'Pay Period',
              title: 'Pay Period',
              ignoreSort: true,
              disableClearable: true
              // isHandleClick: true
            }

          ]}
          defaultSelectedData={defaultSelectedData}
          selectedData={selectedData}
          gridColumn={3}
        />
        {employeeDetails?.length > 0 &&
          <div className="row content ot-box table-list-container">
            <div className="col-sm-12 default-text">
              <FormControl component="fieldset">
                <RadioGroup
                  row
                  aria-label="position"
                  name="position"
                  value={radioValue}
                >
                  {(billingSplitTypeRadio || []).map((col, i) =>
                    <FormControlLabel
                      fontSize="small"
                      className="amount-label-rdo"
                      value={col.value}
                      control={<Radio color="primary"
                        onChange={(event) => {
                          this.handleChange(event);
                        }} />}
                      label={col.title}
                      labelPlacement="end"
                      key={col.value}
                    />
                  )}
                </RadioGroup>
              </FormControl>
              {(this.state.allocationType === 'Market') && mode !== 'View' &&
                <div className="text-align-r" style={{ marginTop: '-26px' }}>
                  <Button
                    variant="contained"
                    color="primary"
                    size="small"
                    startIcon={<AddIcon />}
                    onClick={() => {
                      this.AddNewItem();
                    }}
                  >
                    Add New Market
                  </Button>
                </div>}
              {this.state.allocationType === 'Property Billing' && mode !== 'View' &&
                <div className="text-align-r" style={{ marginTop: '-26px' }}>
                  <Button
                    variant="contained"
                    color="primary"
                    size="small"
                    startIcon={<AddIcon />}
                    onClick={() => {
                      this.AddNewItem();
                    }}
                  >
                    Add New Property
                  </Button>
                </div>}
            </div>
            <div style={{ paddingTop: '10px', paddingBottom: '10px', width: '100%', paddingLeft: '3px' }}>
              {this.renderTableForm(employeeDetails)}
            </div>

            <div className="col-sm-11 col-sm-offset-1 field-control text-align-r" style={{ paddingBottom: '10px', marginRight: '12px' }}>
              {mode !== 'View' && <Button
                variant="contained"
                color="primary"
                size="small"
                disabled={IsSaved}
                startIcon={<SaveIcon />}
                onClick={() => {
                  this.setState({ IsSaved: true }, () => {
                    this.SaveBillingAdjustment();
                  });
                }}
              >
                Submit
              </Button>} &nbsp;&nbsp;
               <Button
                variant="contained"
                color="default"
                size="small"
                startIcon={<ResetIcon />}
                onClick={() => {
                  this.Clear();
                }}
              >
                Cancel
               </Button>
            </div>
          </div>
        }
        <div className="row table-list-container">
          <GridTable
            columns={UpdateColumnWithConfiguration(billingAdjustmentsColumns, configuration)}
            data={billingAdjustmentsData}
            config={billingAdjustmentsConfig}
            reload={reloadTable}
            renderActionColumn={this.renderActionColumn}
          />
        </div>
      </>
    );
  }
}

export default BillingAdjustments;
